import { useCallback } from 'react';

import casesConfig from '../data/case-config.json';
import { CaseMetadata } from '../types';
import {} from '@/utils/sentryHelper';

export const useCasesConfig = () => {
  const getCaseMetadata = useCallback((caseId: string): CaseMetadata | undefined => {
    return casesConfig.cases.find((c) => c.id === caseId);
  }, []);

  const getCaseMetadataByKey = useCallback((caseKey: string): CaseMetadata | undefined => {
    return casesConfig.cases.find((c) => c.caseKey === caseKey);
  }, []);

  return {
    casesConfig,
    getCaseMetadata,
    getCaseMetadataByKey,
    cases: casesConfig.cases || [],
  };
};
